import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  Avatar,
  Checkbox,
  FormControlLabel,
  ListItem,
  ListItemSecondaryAction,
} from '@mui/material';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import axios from 'axios';
import * as htmlToImage from 'html-to-image';
import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  Modal,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';

import CigarStrengthCircles from '@/components/cigar-strength-circles';
import Breadcrumb from '@/components/common/breadcrumb.component';
import BoxpressdTopRatedCard from '@/components/social-rating-card';
import BoxpressdTopRatedStoryCard from '@/components/social-rating-card/reel';
import { Constants } from '@/constants';

const CigarDashboard = (props) => {
  const navigate = useNavigate();
  const [topRated, setTopRated] = React.useState([]);
  const [topRatedWeekly, setTopRatedWeekly] = React.useState([]);
  const [topRatedMonthly, setTopRatedMonthly] = React.useState([]);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [selectedCigar, setSelectedCigar] = React.useState<any | null>(null);
  const [showModal, setShowModal] = React.useState<any | null>(false);
  const [subtitle, setSubtitle] = React.useState<string>('Weekly Top Rated');
  const [cigarImage, setCigarImage] = React.useState<string>(
    'https://cdn.boxpressd.io/cigars/ZOpnelJ1bKBz/vitolas/1742509236582/ZOpnelJ1bKBz-1742509236582.jpeg'
  );
  const [imageRotation, setImageRotation] = React.useState<string | number>(
    -90
  );
  const [imageOffsetX, setImageOffsetX] = React.useState<string | number>(0);
  const [imageOffsetY, setImageOffsetY] = React.useState<string | number>(0);
  const [downloading, setDownloading] = React.useState<boolean>(false);
  const [applyTransparency, setApplyTransparency] =
    React.useState<boolean>(true);
  const [activeTab, setActiveTab] = React.useState<'1' | '2'>('1');

  const postRef = useRef(null);
  const storyRef = useRef(null);

  useEffect(() => {
    axios
      .get(`${Constants.apiPath}/cigars/dashboard`)
      .then((response) => {
        console.log(response.data);
        setTopRated(response.data.top_rated_cigars);
        setTopRatedWeekly(response.data.top_rated_cigars_weekly);
        setTopRatedMonthly(response.data.top_rated_cigars_monthly);
      })
      .catch(() => {});
  }, []);

  const downloadImage = async () => {
    const cardRef = activeTab === '1' ? postRef : storyRef;
    if (!cardRef.current) return;

    try {
      setDownloading(true);

      await document.fonts.ready;

      const dataUrl = await htmlToImage.toPng(cardRef.current, {
        cacheBust: true,
        pixelRatio: 2,
      });

      const link = document.createElement('a');
      link.download = `${selectedCigar.full_name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')}-top-rated.png`;
      link.href = dataUrl;
      link.click();
    } catch (error) {
      console.error('Failed to generate image:', error);
    } finally {
      setDownloading(false);
      setShowModal(false);
    }
  };

  const renderPostModal = () => {
    return (
      <Modal isOpen={showModal} onClosed={() => setShowModal(false)}>
        <div className="modal-header">
          <h5 className="modal-title">Create New Post</h5>
        </div>
        <div className="modal-body">
          <div className="row">
            <div style={{ paddingTop: 10 }}>
              <span>Subtitle</span>
              <input
                name="subtitle"
                className="form-control"
                type="text"
                value={subtitle}
                onChange={(e) => setSubtitle(e.target.value)}
                style={{ textTransform: 'capitalize' }}
                placeholder="Weekly Top Rated"
              />
            </div>
            <div style={{ paddingTop: 10 }}>
              <span>Cigar Image</span>
              <input
                name="cigar-image"
                className="form-control"
                type="text"
                value={cigarImage}
                onChange={(e) => setCigarImage(e.target.value)}
                placeholder="https://cdn.boxpressd.io/cigars/ZOpnelJ1bKBz/vitolas/1742509236582/ZOpnelJ1bKBz-1742509236582.jpeg"
              />
            </div>
            <div
              style={{
                paddingTop: 10,
                paddingBottom: 10,
                display: 'flex',
                gap: 10,
              }}
            >
              <div>
                <span>Image Rotation</span>
                <input
                  name="image-rotation"
                  className="form-control"
                  type="text"
                  value={imageRotation}
                  onChange={(e) => setImageRotation(e.target.value)}
                  placeholder="-90"
                />
              </div>
              <div>
                <span>Image Offset (X)</span>
                <input
                  name="image-offset-x"
                  className="form-control"
                  type="text"
                  value={imageOffsetX}
                  onChange={(e) => setImageOffsetX(e.target.value)}
                  placeholder="0"
                />
              </div>
              <div>
                <span>Image Offset (Y)</span>
                <input
                  name="image-offset-y"
                  className="form-control"
                  type="text"
                  value={imageOffsetY}
                  onChange={(e) => setImageOffsetY(e.target.value)}
                  placeholder="0"
                />
              </div>
            </div>
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={applyTransparency}
                    onChange={(event) =>
                      setApplyTransparency(event.target.checked)
                    }
                  />
                }
                label="Image Transparency"
              />
            </div>
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={activeTab === '1' ? 'active' : ''}
                  onClick={() => setActiveTab('1')}
                  style={{ cursor: 'pointer' }}
                >
                  Post
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === '2' ? 'active' : ''}
                  onClick={() => setActiveTab('2')}
                  style={{ cursor: 'pointer' }}
                >
                  Story / Reel
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab} style={{ margin: 0, padding: 0 }}>
              <TabPane tabId="1">
                <div
                  style={{
                    transform: 'scale(0.54)',
                    transformOrigin: 'top left',
                    width: 1080 * 0.54,
                    height: 1080 * 0.54,
                    border: '1px solid #ddd',
                  }}
                >
                  <BoxpressdTopRatedCard
                    ref={postRef}
                    title="COMMUNITY PICK"
                    subtitle={subtitle}
                    cigarBrand={selectedCigar?.brand}
                    cigarName={selectedCigar?.name}
                    country={selectedCigar?.origin}
                    rating={
                      selectedCigar?.avg_rating ??
                      (selectedCigar?.rating != null
                        ? Math.round(selectedCigar.rating * 20)
                        : undefined)
                    }
                    cigarImage={`https://img.boxpressd-proxy.com/img?src=${cigarImage}&rotate=${imageRotation}${applyTransparency ? '&bg=remove' : ''}`}
                    imageOffsetX={parseInt(imageOffsetX, 10) || 0}
                    imageOffsetY={parseInt(imageOffsetY, 10) || 0}
                    accentColor="#d3a966"
                    footerText={`Based on ${selectedCigar?.total_ratings > 1 ? `${selectedCigar?.total_ratings} ` : ''}user ratings.`}
                    strengthContent={
                      <div
                        style={{
                          fontFamily: 'Arial, Helvetica, sans-serif',
                          fontSize: 34,
                          color: '#efefef',
                          lineHeight: 1.4,
                        }}
                      >
                        Strength
                        <CigarStrengthCircles
                          strength={selectedCigar?.strength}
                          diameter={44}
                          style={{
                            display: 'flex',
                            margin: '10px auto',
                            justifyContent: 'center',
                          }}
                        />
                      </div>
                    }
                  />
                </div>
              </TabPane>
              <TabPane tabId="2">
                <div
                  style={{
                    width: 1080 * 0.54,
                    height: 1920 * 0.54,
                    background: '#121212',
                  }}
                >
                  <div
                    style={{
                      transform: 'scale(0.54)',
                      transformOrigin: 'top left',
                    }}
                  >
                    <BoxpressdTopRatedStoryCard
                      ref={storyRef}
                      title="COMMUNITY PICK"
                      subtitle={subtitle}
                      cigarBrand={selectedCigar?.brand}
                      cigarName={selectedCigar?.name}
                      country={selectedCigar?.origin}
                      rating={
                        selectedCigar?.avg_rating ??
                        (selectedCigar?.rating != null
                          ? Math.round(selectedCigar.rating * 20)
                          : undefined)
                      }
                      cigarImage={`https://img.boxpressd-proxy.com/img?src=${cigarImage}&rotate=${imageRotation}${applyTransparency ? '&bg=remove' : ''}`}
                      imageOffsetX={parseInt(imageOffsetX, 10) || 0}
                      imageOffsetY={parseInt(imageOffsetY, 10) || 0}
                      accentColor="#d3a966"
                      footerText={`Based on ${selectedCigar?.total_ratings > 1 ? `${selectedCigar?.total_ratings} ` : ''}user ratings.`}
                      strengthContent={
                        <div
                          style={{
                            fontFamily: 'Arial, Helvetica, sans-serif',
                            fontSize: 34,
                            color: '#efefef',
                            lineHeight: 1.4,
                          }}
                        >
                          Strength
                          <CigarStrengthCircles
                            strength={selectedCigar?.strength}
                            diameter={44}
                            style={{
                              display: 'flex',
                              margin: '10px auto',
                              justifyContent: 'center',
                            }}
                          />
                        </div>
                      }
                    />
                  </div>
                </div>
              </TabPane>
            </TabContent>
          </div>
        </div>
        <div className="modal-footer">
          <Button onClick={() => setShowModal(false)}>Cancel</Button>
          <Button
            onClick={downloadImage}
            variant="contained"
            color="secondary"
            disabled={downloading}
          >
            {downloading ? 'Generating...' : 'Download Image'}
          </Button>
        </div>
      </Modal>
    );
  };

  return (
    <>
      <Breadcrumb title={'Cigar Dashboard'} label="Editor" parent="Cigars" />

      <div style={{ display: 'flex' }}>
        <Card style={{ flex: 1, margin: 10 }}>
          <h5 style={{ margin: '12px 22px 8px' }}>Overall Top Rated</h5>
          <List>
            {topRated.length > 0 &&
              topRated.map((cigar) => (
                <ListItem
                  key={`cigar-item-${cigar.cigar_id}`}
                  onClick={() => {}}
                >
                  <Avatar
                    variant="square"
                    style={{ marginRight: 10, height: 40, width: 40 }}
                  >
                    {cigar.avg_rating || Math.round(cigar.rating * 20)}
                  </Avatar>
                  <ListItemText
                    primary={
                      <span
                        className="padded-multiline"
                        style={{ marginLeft: 10 }}
                      >
                        {cigar.full_name.replace(' null', '').trim()}
                      </span>
                    }
                  />
                  <ListItemSecondaryAction>
                    <button
                      className="btn btn-secondary"
                      onClick={(event) => {
                        setAnchorEl(event.currentTarget);
                        setSelectedCigar(cigar);
                      }}
                      style={{
                        padding: '6px 14px',
                        float: 'right',
                        marginLeft: '10px',
                      }}
                    >
                      <MoreVertIcon />
                    </button>
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            {topRated.length === 0 && (
              <div style={{ textAlign: 'center', margin: 10 }}>
                No cigars found
              </div>
            )}
          </List>
        </Card>
        <Card style={{ flex: 1, margin: 10 }}>
          <h5 style={{ margin: '12px 22px 8px' }}>Weekly Top Rated</h5>
          <List>
            {topRatedWeekly.length > 0 &&
              topRatedWeekly.map((cigar) => (
                <ListItem
                  key={`cigar-item-${cigar.cigar_id}`}
                  onClick={() => {}}
                >
                  <Avatar
                    variant="square"
                    style={{ marginRight: 10, height: 40, width: 40 }}
                  >
                    {cigar.avg_rating || Math.round(cigar.rating * 20)}
                  </Avatar>
                  <ListItemText
                    primary={
                      <span
                        className="padded-multiline"
                        style={{ marginLeft: 10 }}
                      >
                        {cigar.full_name.replace(' null', '').trim()}
                      </span>
                    }
                  />
                  <ListItemSecondaryAction>
                    <button
                      className="btn btn-secondary"
                      onClick={(event) => {
                        setAnchorEl(event.currentTarget);
                        setSelectedCigar(cigar);
                      }}
                      style={{
                        padding: '6px 14px',
                        float: 'right',
                        marginLeft: '10px',
                      }}
                    >
                      <MoreVertIcon />
                    </button>
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            {topRatedWeekly.length === 0 && (
              <div style={{ textAlign: 'center', margin: 10 }}>
                No cigars found
              </div>
            )}
          </List>
        </Card>
        <Card style={{ flex: 1, margin: 10 }}>
          <h5 style={{ margin: '12px 22px 8px' }}>Monthly Top Rated</h5>
          <List>
            {topRatedMonthly.length > 0 &&
              topRatedMonthly.map((cigar) => (
                <ListItem
                  key={`cigar-item-${cigar.cigar_id}`}
                  onClick={() => {}}
                >
                  <Avatar
                    variant="square"
                    style={{ marginRight: 10, height: 40, width: 40 }}
                  >
                    {cigar.avg_rating || Math.round(cigar.rating * 20)}
                  </Avatar>
                  <ListItemText
                    primary={
                      <span
                        className="padded-multiline"
                        style={{ marginLeft: 10 }}
                      >
                        {cigar.full_name.replace(' null', '').trim()}
                      </span>
                    }
                  />
                  <ListItemSecondaryAction>
                    <button
                      className="btn btn-secondary"
                      onClick={(event) => {
                        setAnchorEl(event.currentTarget);
                        setSelectedCigar(cigar);
                      }}
                      style={{
                        padding: '6px 14px',
                        float: 'right',
                        marginLeft: '10px',
                      }}
                    >
                      <MoreVertIcon />
                    </button>
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            {topRatedMonthly.length === 0 && (
              <div style={{ textAlign: 'center', margin: 10 }}>
                No cigars found
              </div>
            )}
          </List>
        </Card>
      </div>
      <Menu
        id={`menu-cigar-item`}
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          disableRipple
          onClick={() => {
            console.log('Generating post for:', selectedCigar);
            setShowModal(true);
            setAnchorEl(null);
          }}
        >
          Generate Social Media Post
        </MenuItem>
      </Menu>
      {renderPostModal()}
    </>
  );
};

export default CigarDashboard;
